module.exports = __webpack_public_path__ + "img/ziyuanbao.55dca14f.png";